import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const SuspendedPage = lazy(() => import('.'))

class SuspendedPageComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['reason']
  }

  override render() {
    const reason = this.prop('reason')

    return (
      <PageRoot>
        <SuspendedPage reason={reason} />
      </PageRoot>
    )
  }
}

customElements.define('suspended-page', SuspendedPageComponent)
